import { Injectable } from '@angular/core';
import { ConfigService } from '@icc/shared';
import { Country } from '../interfaces/country.interface';
import { Region } from '../interfaces/region.interface';

@Injectable({
    providedIn: 'root',
})
export class CountriesService {
    countries: Country[] = [];
    regions: Region[] = [];

    constructor(private configService: ConfigService) {}

    loadCountries() {
        this.countries = this.configService.config.countries;
        this.regions = this.configService.config.regions;
    }

    getCountry(id: string) {
        const country = this.countries.find(c => c.id === id);

        if (country?.id) {
            country.name = new (Intl as any).DisplayNames([this.configService.config.languageCode], {type: 'region'}).of(country?.id)
        }
        return country;
    }

    getCountries() {
        return this.countries.map(country => {
            if (country?.id) {
                country.name = new (Intl as any).DisplayNames([this.configService.config.languageCode], {type: 'region'}).of(country?.id)
            }
            return country;
        });
    }

    getRegions(countryId: string) {
        return this.regions.filter(region => region.countryId === countryId);
    }
}
